import { makeStyles } from '@material-ui/styles';
import { MenuItem, Select, TextField } from '@material-ui/core';
import { useState } from 'react';
import { useTranslation } from '../../../tools/i18n';
import useUserStore from '../../../services/stores/UserStore';
import CallToActionButton from '../partials/CallToActionButton';
import theme from '../../theme';
import Link from 'next/link';

const useStyles = makeStyles(() => ({
    createWishlistActions: {
        display: 'flex',
        [theme.breakpoints.down('xs')]: {
            width: '100%',
        },
    },
    createButton: {
        gridColumn: '1 / -1',
        background: theme.palette.primary.blue,
        color: '#fff',
        padding: '10px 40px',
        textDecoration: 'none',
        fontSize: '1.2em',
        width: '100%',
        textAlign: 'center',
    },
    selectInput: {
        marginBottom: '-15px',
        width: 'min-content'
    },
    createWishlistInputWrapper: {
        flexGrow: 1,
        flexBasis: '45%'
    }
}), { name: 'CreateWishlist' });

export default function CreateWishlist(
    {
        show = true,
        type = 'standard'
    },
) {
    const [ wishlistType, setWishlistType ] = useState(type);
    const [ wishlistName, setWishlistName ] = useState();
    const classes = useStyles();
    const { t } = useTranslation();
    const user = useUserStore();

    if (!show) {
        return null;
    }

    return <>
        <div className={classes.createWishlistActions}>
            <Link href={"/account/wishlists/create"}>
                <a className={classes.createButton} href={"/account/wishlists/create"}>
                    {t('new-wishlist-button')}
                </a>
            </Link>
        </div>
    </>;
}
